import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNode } from 'react';
import { BrowserRouter } from 'react-router';

import { shouldRetryQuery } from './api/queries';
import initSentry from './common/sentry';

if (process.env.ENABLE_SENTRY) {
  initSentry();
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Don't refetch data in the background on each page render.
      // Only refetch after 10 minutes by default.
      staleTime: 10 * 60 * 1000,
      // Keep data in cache for up to 15 minutes.
      gcTime: 15 * 60 * 1000,
      retry: shouldRetryQuery,
    },
  },
});

export default function AppProvider({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>{children}</BrowserRouter>
    </QueryClientProvider>
  );
}
